// theme.js
import { createTheme } from '@mui/material/styles';
import { headingLetterSpacing } from './utils/headingTypography';

// Mirrored in src/staticHero/staticHero.css (docs/static-hero.md):
// layout.pageShell, body1 typography, the CssBaseline heading rules and the
// MuiButton overrides. Change both, or landing pages jump when React takes over.
const theme = createTheme({
  spacing: 8,
  layout: {
    pageShell: {
      mt: { xs: 2, sm: 4, md: 4 },
      mb: { xs: 3, sm: 4, md: 4 },
    },
  },
  typography: {
    fontFamily: 'Inter, Inter-Fallback, sans-serif',
    h1: {
      fontWeight: 700,
      fontSize: '2.5rem',
      letterSpacing: headingLetterSpacing('2.5rem'),
    },
    h2: {
      letterSpacing: headingLetterSpacing('3.75rem'),
    },
    h3: {
      letterSpacing: headingLetterSpacing('3rem'),
    },
    h4: {
      letterSpacing: headingLetterSpacing('2.125rem'),
    },
    h5: {
      letterSpacing: headingLetterSpacing('1.5rem'),
    },
    h6: {
      letterSpacing: headingLetterSpacing('1.25rem'),
    },
    body1: {
      fontSize: '16px',
      color: '#1E354E',
    },
    body2: {
      fontSize: '16px',
      color: '#738289',
    },
  },
  palette: {
    primary: {
      main: '#9ea900', // Deep Hippo Green
    },
    secondary: {
      main: '#C7CA00', // Fresh Hippo Green
    },
    background: {
      default: '#FFFFFF',
    },
    component: {
      border: '#e0e0e0',
      text: '#757575',
      buttonText: '#1C2F3A',
      cardText: '#3D3D3D',
      title: '#1C2F3A',
      placeholder: '#757575',
      autocomplete: '#757575',
      valid: '#c7cboo',
      error: '#D32F2F',
      background: '#F6F6F6',
      critical: '#ff0074', // for primary-pink
      message: '#4a4f55', // modal-message
    },
    test: {
      main: '#ffff00',
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        p: {
          marginBottom: 0,
        },
        h1: {
          textWrap: 'balance',
          orphans: 2,
        },
        h2: {
          textWrap: 'balance',
          orphans: 2,
        },
        h3: {
          textWrap: 'balance',
          orphans: 2,
        },
        h4: {
          textWrap: 'balance',
          orphans: 2,
        },
        h5: {
          textWrap: 'balance',
          orphans: 2,
        },
        h6: {
          textWrap: 'balance',
          orphans: 2,
        },
      },
    },
    MuiButtonBase: {
      defaultProps: {
        disableRipple: true,
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          transition: 'none !important',
          animation: 'none !important',
          boxShadow: 'none !important',
          textTransform: 'none',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          transition: 'none !important',
          animation: 'none !important',
        },
      },
    },
  },
});

export default theme;
